import { render, staticRenderFns } from "./FileCodesErrors.vue?vue&type=template&id=32e15e3b&"
import script from "./FileCodesErrors.vue?vue&type=script&lang=ts&"
export * from "./FileCodesErrors.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports